<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav :menuItems="menuItems" class="side-nav"></side-nav>

      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';

export default {
  name: 'Regattas',

  components: {
    MyHeader,
    SideNav,
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Регаты',
          route: {name: 'regatta_list'},
          exact: true,
        },
      ];

      return items;
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 1em;
}
</style>
